import clarity from '@microsoft/clarity';

const clarityProjectId = process.env.REACT_APP_CLARITY_PROJECT_ID;
let clarityInitialized = false;

const grantedConsent = {
  ad_Storage: 'denied',
  analytics_Storage: 'granted',
};

const deniedConsent = {
  ad_Storage: 'denied',
  analytics_Storage: 'denied',
};

function initializeClarity() {
  if (clarityInitialized || typeof window === 'undefined' || !clarityProjectId) {
    return clarityInitialized;
  }

  clarity.init(clarityProjectId);
  clarityInitialized = true;
  return true;
}

export function syncClarityConsent(consent) {
  if (consent?.analytics === true) {
    if (!initializeClarity()) return false;
    clarity.consentV2(grantedConsent);
    return true;
  }

  if (clarityInitialized) {
    clarity.consentV2(deniedConsent);
    clarity.consent(false);
  }

  return false;
}
